module.exports = __webpack_public_path__ + "static/media/classting-app-logo.1b697684.svg";